export const en = {
  task: 'Task',
  back: 'Back',
  open: 'Open',
  closed: 'Closed',
  viewInTaskBoard: 'View in Task Board'
};

export type Translations = typeof en;
